import seedrandom from 'seedrandom';
import dayjs from 'dayjs';

function clamp(n, min, max) { return Math.max(min, Math.min(n, max)); }

export function simulateMetrics({ seed='global', sent=1000 }) {
  const rng = seedrandom(seed);
  const bounceRate = clamp(rng() * 0.08, 0.01, 0.08);
  const delivered = Math.round(sent * (1 - bounceRate));
  const openRate = clamp(0.15 + rng() * 0.35, 0.15, 0.5);
  const clickRate = clamp(openRate * (0.1 + rng() * 0.5), 0.03, 0.25);
  const unsubRate = clamp(rng() * 0.01, 0.0005, 0.01);
  const complaintRate = clamp(rng() * 0.003, 0.0002, 0.003);

  const opens = Math.round(delivered * openRate);
  const clicks = Math.round(opens * clickRate);
  const bouncesSoft = Math.round(sent * bounceRate * 0.7);
  const bouncesHard = Math.round(sent * bounceRate * 0.3);
  const unsubscribes = Math.round(delivered * unsubRate);
  const complaints = Math.round(delivered * complaintRate);

  // timeseries for last 24h
  const timeseries = Array.from({ length: 24 }, (_, i) => ({
    t: dayjs().subtract(23 - i, 'hour').toISOString(),
    opens: Math.round(opens / 24 * (0.6 + rng())),
    clicks: Math.round(clicks / 24 * (0.6 + rng())),
  }));

  return {
    sent,
    delivered,
    opens,
    clicks,
    bouncesHard,
    bouncesSoft,
    unsubscribes,
    complaints,
    timeseries
  };
}
